import { Component, OnInit, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  windowsWidth;
  @Input() pageNumber = 0;
  @Input() previousRoute;
  @Input() nextRoute;
  @Input() previousText;
  @Input() nextText;

  disclaimerActive = false;
  termOfUseActive = false;
  privacyActive = false;
  newsletterActive = false;

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

}
